module.exports = __webpack_public_path__ + "img/p15072.8f5b18c5.jpg";